import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Paper,
  Typography,
} from "@mui/material"
import { useMarginsDiscounts } from "hooks/margin/useMarginsDiscounts"

export const CLIENT = "CLIENT"
export const COST = "COST"
export const NOT_SET = "NOT_SET"

const FormulasTab = ({ isBudgetClosed = false }) => {
  const { state, setIsClientPrice } = useMarginsDiscounts()

  const handleChange = event => {
    setIsClientPrice(event.target.value === CLIENT)
  }

  return (
    <Grid container spacing={2}>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              borderRadius: 2,
            }}
          >
            <Typography sx={{ mb: 3, p: 1 }}>
              {i18n.t("formulasTab.title")}
            </Typography>
            <Grid container item spacing={2}>
              <Grid container item spacing={2}>
                <Grid item xs={12}>
                  <FormControl disabled={isBudgetClosed}>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={state.formulas.isClientPrice ? CLIENT : COST}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value={COST}
                        disabled={isBudgetClosed}
                        control={<Radio />}
                        label={i18n.t("formulasTab.cost")}
                      />
                      <FormControlLabel
                        value={CLIENT}
                        disabled={isBudgetClosed}
                        control={<Radio />}
                        label={i18n.t("formulasTab.client")}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}

FormulasTab.propTypes = {
  isBudgetClosed: PropTypes.bool,
}

export default FormulasTab
